/* eslint-disable parog-web/no-glint-expect-error-directive */
import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import FuiDropdown from 'parog-web/components/fui-dropdown';
import FormyField from './field';
import FormyComponent from '../formy';

type Args = (
  | { parent: FormyComponent; key: string }
  | { parent: FormyField; key: never }
) & { defaultText: string };

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class FormySelectComponent extends Component<Signature> {
  get changeset(): EmberChangeset {
    return this.#formy.args.changeset;
  }

  get id(): FormyField['id'] | undefined {
    return this.args.parent instanceof FormyField
      ? this.args.parent.id
      : undefined;
  }

  get isSelected(): boolean | undefined {
    const proxy = this.changeset.get(this.#key);
    if (!proxy) return undefined;

    // We want the `content` and not the Proxy object
    return proxy.content;
  }

  get #formy(): FormyComponent {
    if (this.args.parent instanceof FormyComponent) return this.args.parent;
    return this.args.parent.args.formy;
  }

  get #key(): string {
    return this.args.parent instanceof FormyField
      ? this.args.parent.args.key
      : this.args.key;
  }

  <template>
    <FuiDropdown
      @id={{this.id}}
      class='selection'
      {{! @glint-expect-error }}
      @selected={{this.isSelected}}
      @settings={{hash onChange=(changesetSet this.changeset @key)}}
      ...attributes
    >
      <:defaultText>{{@defaultText}}</:defaultText>
      <:menu as |Item|>

        {{! @glint-expect-error }}
        {{yield Item}}
      </:menu>
    </FuiDropdown>
  </template>
}
